import { TriStateFilterValue } from '@entities/clients';
import { RadioButton } from '@shared/ui/kit';
import styles from '../filter-clients.module.scss';

interface FilterRadioGroupProps {
  label: string;
  value: TriStateFilterValue;
  onChange: (value: TriStateFilterValue) => void;
  options: { value: TriStateFilterValue; label: string }[];
  isDisabled?: boolean;
}

interface FilterRadioOptionProps {
  option: FilterRadioGroupProps['options'][number];
  value: TriStateFilterValue;
  onChange: FilterRadioGroupProps['onChange'];
  isDisabled?: boolean;
}

const FilterRadioOption = ({ option, value, onChange, isDisabled }: FilterRadioOptionProps) => {
  const handleChange = () => onChange(option.value);

  return (
    <label className={styles.radioOption}>
      <RadioButton
        isChecked={value === option.value}
        changeFunction={handleChange}
        size="small"
        isDisabled={isDisabled}
      />
      {option.label}
    </label>
  );
};

export const FilterRadioGroup = ({ label, value, onChange, options, isDisabled }: FilterRadioGroupProps) => (
  <div className={styles.filterGroup}>
    <span className={styles.filterLabel}>{label}</span>

    <div className={styles.radioGroup}>
      {options.map((option) => (
        <FilterRadioOption
          key={String(option.value)}
          option={option}
          value={value}
          onChange={onChange}
          isDisabled={isDisabled}
        />
      ))}
    </div>
  </div>
);
